import React, { createContext, useState, useContext } from "react";
import useAxios from "../api/useAxios";
import "../../node_modules/noty/lib/noty.css";
import { toast } from "react-toastify";
import { useSearchParams } from "react-router-dom";
import AuthContext from "./AuthContext";
import $ from "jquery";
const OrderContext = createContext();

export default OrderContext;

export const OrderProvider = ({ children }) => {
  const EMAIL_ADDRESS = "partner@mybudapester.com";

  const [searchParams, setSearchParams] = useSearchParams({ replace: true });

  let { user } = useContext(AuthContext);

  let [loader, setLoader] = useState(true);

  let [page, setPage] = useState(1);
  let [limit, setLimit] = useState(100);
  let [totalItems, setTotalItem] = useState(null);

  // FILTERS
  const [processed, setProcessed] = useState(false);
  const [orderby, setOrderby] = useState();
  const [shippingstatus, setShippingStatus] = useState("");
  const [orderstatus, setOrderStatus] = useState("");
  const [vendor, setVendor] = useState("");
  const [search, setSearch] = useState("");
  const [searchValue, setSearchValue] = useState("");

  const [from, setDateFrom] = useState("");
  const [to, setDateTo] = useState("");

  // MODALS
  const [orderID, setOrderID] = useState(null);
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [isCommentsModalOpen, toggleCommentsModal] = useState(false);
  const [isDetailsModalOpen, toggleDetailsModal] = useState(false);
  const [isInvocesModalOpen, toggleInvocesModal] = useState(false);
  const [isSLModalOpen, toggleSLModal] = useState(false);
  // ORDER
  const [orderData, setOrderData] = useState([]);

  const [confirmReturn, setConfirmReturn] = useState(false);
  const [toRetuen, setToReturn] = useState([]);
  const [priceSum, setPriceSum] = useState(null);

  let api = useAxios();

  let fetchData = async () => {
    const params = Object.fromEntries([...searchParams]);
    let response = await api.get(
      `/manager/order?sort_by=saleTime&processed=${processed}${
        !user.roles.includes("ROLE_all-seeing") ? "&visible=true" : ""
      }`,
      {
        params,
      }
    );
    if (response.status === 200) {
      setTotalItem(response.data.totalItems);
      return response.data;
    }
  };

  let csvexport = async () => {
    console.log("csvexport API");
    api
      .get(
        `https://panelapi-dev.budapester.com/manager/order_export?format=CSV&sort_by=orderId`,
        {
          responseType: "application/json",
          contentType: "application/json; charset=utf-8",
        }
      )
      .then((res) => {
        console.log(res);
        const linkSource = `data:application/json;base64,${res.data.content}`;
        const downloadLink = document.createElement("a");
        const fileName = "ORDERS.csv";
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch((error) => {
        toast.error(`Something went wrong!.`, {
          position: "bottom-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      });
  };

  let orderPeocess = async (id) => {
    const data = { value: true };
    api
      .put(`/manager/order/${id}/processed`, data)
      .then((response) => {
        toast.success(`Order ${id} processed`, {
          position: "bottom-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });

        const element = document.getElementById(`${id}-element`);
        element.classList.add("remove");
        setTimeout(function () {
          element.remove();
        }, 300);
      })
      .catch((error) => {
        toast.error(`Something went wrong!`, {
          position: "bottom-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      });
  };

  let orderVisable = async (id, status) => {
    const data = { value: !status };
    api
      .put(`/manager/order/${id}/visibility`, data)
      .then((response) => {
        toast.success(`Order ${id} visability changed`, {
          position: "bottom-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });

        const btn = document.getElementById(`row-visible-${id}`);
        if (!btn.classList.contains("active")) {
          btn.classList.add("active");
        } else if (btn.classList.contains("active")) {
          btn.classList.remove("active");
        }
      })
      .catch((error) => {
        toast.error(`Something went wrong!`, {
          position: "bottom-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      });
  };

  // COMMENTS BY ORDER ID
  let addComment = async (comment, id) => {
    const data = { content: comment };
    api
      .post(`/manager/order/${id}/comment`, data)
      .then((response) => {
        toast.success(`Order ${id} comment add..`, {
          position: "bottom-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
        closeModal();
      })
      .catch((error) => {
        toast.error(`Something went wrong!.`, {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      });
  };

  let clearFilters = () => {
    setOrderby("");
    setSearchParams("");
    setShippingStatus("");
    setOrderStatus("");
    setVendor("");
  };

  let clearDateRange = () => {
    setSearchParams("");
    setDateFrom("");
    setDateTo("");
  };

  let getOrderDataID = async (id) => {
    let response = await api.get(`/manager/order/${id}`);
    if (response.status === 200) {
      setOrderData(response);

      const arr = [];
      const products = response?.data.products;
      products.map((i) => {
        arr.push(parseInt(i.price.value));
      });
      const sum = arr.reduce((partialSum, a) => partialSum + a, 0);

      setPriceSum(sum.toFixed(2));

      setLoader(false);
    }
  };

  let getComments = (id) => {
    getOrderDataID(id);
    toggleCommentsModal(true);
    setIsOpen(true);
  };

  // ORDER Details
  let getOrderDetails = async (id) => {
    setIsOpen(true);
    toggleDetailsModal(true);
    setOrderID(id);
  };

  let getInvoces = async (id) => {
    setIsOpen(true);
    toggleInvocesModal(true);
    setOrderID(id);
  };

  let getShippingLabel = async (id) => {
    setIsOpen(true);
    toggleSLModal(true);
    setOrderID(id);
  };

  // MODALS CONTEXT

  let closeModal = () => {
    setIsOpen(false);
    toggleDetailsModal(false);
    toggleCommentsModal(false);
    toggleInvocesModal(false);
    toggleSLModal(false);
    setLoader(true);
  };

  // let sendEmail = (email, subject, message) => {
  //   const data = {
  //     addressees: [
  //       {
  //         email: email,
  //       },
  //     ],
  //     subject: subject,
  //     html: message,
  //     text: "You see this if your e-mail client cannot html",
  //   };
  //   api.post(`/manager/mail`, data);
  // };

  let downloadInvloce = async (orderid, id) => {
    api
      .get(`/manager/order/${orderid}/invoice/${id}`, {
        responseType: "application/json",
        contentType: "application/json; charset=utf-8",
      })
      .then((res) => {
        const linkSource = `data:application/pdf;base64,${res.data.file}`;
        const downloadLink = document.createElement("a");
        const fileName = "Invoice-" + res.data.id + ".pdf";
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        const todayDate = new Date().toISOString().slice(0, 10);
        console.log(todayDate);
        api
          .put(`manager/order/${orderid}/invoice/${id}/printed_at`, {
            dateTime: `${todayDate}T13:42:03.227+02:00`,
          })
          .then((res) => {
            closeModal();
            enableProcess(orderid);
          });
      })
      .catch((error) => {
        toast.error(`Something went wrong!.`, {
          position: "bottom-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      });
  };

  let downloadShippingLabel = async (orderid, id) => {
    api
      .get(`/manager/order/${orderid}/shipping/${id}/shipping_label`, {
        responseType: "application/json",
        contentType: "application/json; charset=utf-8",
      })
      .then((res) => {
        const linkSource = `data:application/pdf;base64,${res.data.base64}`;
        const downloadLink = document.createElement("a");
        const fileName = "Shipping-label-" + res.data.id + ".pdf";
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();

        api
          .put(`manager/order/${orderid}/shipping/${id}/printed_at`, {
            dateTime: "2019-08-13T13:42:03.227+02:00",
          })
          .then((res) => {
            // const element = document.getElementById(`shippinglabel-${orderid}`)
            // element.classList.add("success");
            // element.classList.add("bounce");
            // const row = document.getElementById(`${orderid}-element`)
            // row.classList.add('flash')
            closeModal();
            enableProcess(orderid);
          });
      })
      .catch((error) => {
        toast.error(`Something went wrong!.`, {
          position: "bottom-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      });
  };

  let availabilityProductConfirm = (arr, orderid) => {
    for (let i = 0; i < arr.length; i++) {
      api
        .put(`/manager/order/${orderid}/product/${arr[i].item}/availability`, {
          status: arr[i].value,
        })
        .then((res) => {
          api
            .put(
              `/manager/order/${orderid}/product/${arr[i].item}/availability_verified_at`,
              {
                dateTime: "2019-08-13T13:42:03.227+02:00",
              }
            )
            .then((res) => {
              const row = document.getElementById(`${orderid}-element`);
              row.classList.add("flash");
              row.classList.add("hidden");
              enableProcess(orderid);
            });

          if (i + 1 === arr.length) {
            toast.success(`Stock confirmed!`, {
              position: "bottom-center",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: 0,
            });
            closeModal();
          }
        })
        .catch((error) => {
          toast.error(`Something went wrong!.`, {
            position: "bottom-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
        });
    }
  };

  let productReturn = (qty, orderId, productId) => {
    api
      .put(`/manager/order/${orderId}/product/${productId}/return`, {
        returned: true,
        qtyDiff: qty,
      })
      .then((res) => {
        setToReturn([]);
        setConfirmReturn(false);

        toast.success(`Products returned sucess!`, {
          position: "bottom-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });

        const element = document.getElementById(`row-id-${productId}`);
        element.classList.add("returned");
      })
      .catch((error) => {
        toast.error(`Something went wrong!.`, {
          position: "bottom-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      });
  };

  let putSentStatus = (orderId, vendorid) => {
    api
      .put(`/manager/order/${orderId}/sent_status`, {
        vendorId: vendorid,
        isSent: true,
      })

      .then((res) => {
        toast.success(`Status Changed.`, {
          position: "bottom-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
        const element = document.getElementById(`row-versendet-${orderId}`);
        element.classList.add("redbtn");
        element.disabled = true;
      })
      .catch((error) => {
        toast.error(`Something went wrong!.`, {
          position: "bottom-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      });
  };

  let enableProcess = (id) => {
    const stock = $(`#stoct-check-${id}`).hasClass("success");
    const shippinglabel = $(`#shippinglabel-${id}`).hasClass("success");
    const invoce = $(`#invoce-${id}`).hasClass("success");

    if (stock && shippinglabel && invoce) {
      $("#btn-process-" + id).removeClass("disabled");
    }
  };

  let contextOrderData = {
    page: page,
    setPage: setPage,
    fetchData: fetchData,
    totalItems: totalItems,
    limit: limit,
    setLimit: setLimit,
    processed: processed,
    setProcessed: setProcessed,

    search: search,
    setSearch: setSearch,

    searchValue: searchValue,
    setSearchValue: setSearchValue,

    orderby: orderby,
    setOrderby: setOrderby,
    shippingstatus: shippingstatus,
    setShippingStatus: setShippingStatus,
    orderstatus: orderstatus,
    setOrderStatus: setOrderStatus,
    vendor: vendor,
    setVendor: setVendor,

    confirmReturn: confirmReturn,
    setConfirmReturn: setConfirmReturn,

    from: from,
    setDateFrom: setDateFrom,
    to: to,
    setDateTo: setDateTo,

    orderPeocess: orderPeocess,
    orderVisable: orderVisable,

    getComments: getComments,
    getOrderDetails: getOrderDetails,
    getInvoces: getInvoces,
    getShippingLabel: getShippingLabel,

    downloadInvloce: downloadInvloce,

    downloadShippingLabel: downloadShippingLabel,

    orderData: orderData,
    setOrderData: setOrderData,
    csvexport: csvexport,

    modalIsOpen: modalIsOpen,
    setIsOpen: setIsOpen,
    closeModal: closeModal,

    isCommentsModalOpen: isCommentsModalOpen,
    toggleCommentsModal: toggleCommentsModal,

    isDetailsModalOpen: isDetailsModalOpen,
    toggleDetailsModal: toggleDetailsModal,

    isInvocesModalOpen: isInvocesModalOpen,
    toggleInvocessModal: toggleInvocesModal,

    isSLModalOpen: isSLModalOpen,
    toggleSLModal: toggleSLModal,

    searchParams: searchParams,
    setSearchParams: setSearchParams,

    clearFilters: clearFilters,
    clearDateRange: clearDateRange,

    addComment: addComment,
    putSentStatus: putSentStatus,

    availabilityProductConfirm: availabilityProductConfirm,

    productReturn: productReturn,

    toRetuen: toRetuen,
    setToReturn: setToReturn,

    orderID: orderID,
    setOrderID: setOrderID,
    getOrderDataID: getOrderDataID,
    priceSum: priceSum,

    loader: loader,
    setLoader: setLoader,
  };

  return (
    <OrderContext.Provider value={contextOrderData}>
      {children}
    </OrderContext.Provider>
  );
};
